import styled from "styled-components";
import { colorTheme, textTheme } from "../../theme";

export const Container = styled.div<{
  isHovered: boolean;
  height: any;
  width: any;
}>`
  height: ${props => (props.height ? props.height : "167px")};
  width: ${props => (props.width ? props.width : "262px")};
  border: 1px solid ${colorTheme.divider};
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.06);
  border-radius: 4px;
  box-sizing: border-box;

  &:hover {
    border: ${props =>
      props.isHovered
        ? `1px solid ${colorTheme.newBlue};`
        : `1px solid ${colorTheme.divider};`};
  }
`;

export const Spinner = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const HoverItem = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 10px 0px 3px 0px;
  ${textTheme.body1};
  color: ${colorTheme.grayDark};
  &:not(:last-child) {
    border-bottom: 1px solid ${colorTheme.divider};
  }
`;

export const HoverTitle = styled.div``;

export const HoverValue = styled.div``;

export const ContentContainer = styled.div<{
  isHovered: boolean;
  hoverStateData: any;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${props =>
    props.isHovered && props.hoverStateData ? "5px 25px" : "31px 0px"};
`;

export const Title = styled.span`
  ${textTheme.subtitle2};
  color: ${colorTheme.grayDark};
`;

export const Value = styled.span`
  ${textTheme.price};
  color: ${colorTheme.black};
  margin: 5px 0px;
`;

// export const Trend = styled.span<InformationTileProps>`
//   display: flex;
//   align-items: center;

//   ${textTheme["Tile-Trend"]}
//   color: ${props => (
//     props.trend && props.trend > 0
//     ? colorTheme.green
//     : colorTheme.red
//   )}
// `;

// export const Icon = styled.img`
//   margin-right: 4px;
// `;
